import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME, EXPORT_FILE_NAME } from './constants';


class SestavyApi extends BaseApi {
	constructor() {
		super(DMS_MODULE, API_NAME);
	}

	async GetLabourSalesReport(parameter: any, columnsSeq: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${API_NAME}/GetLabourSalesReport?${parameter}&ColumnSequence=${columnsSeq}`, EXPORT_FILE_NAME);
	}
}


export const apiProvider = new SestavyApi();
